/* Home Bliss Rack: basic copy protection for shoppers (19 Oct 2026, merchant request).
   Blocks right-click, image dragging, text selection/copy and common "view source / save / inspect" shortcuts.
   Form fields (search, cart notes, checkout inputs) still work normally. */
(function () {
  var isField = function (el) { return el && el.closest && el.closest('input, textarea, select, [contenteditable="true"]'); };
  document.addEventListener('contextmenu', function (e) { if (!isField(e.target)) e.preventDefault(); });
  document.addEventListener('dragstart', function (e) { if (e.target && e.target.tagName === 'IMG') e.preventDefault(); });
  document.addEventListener('copy', function (e) { if (!isField(e.target)) e.preventDefault(); });
  document.addEventListener('cut', function (e) { if (!isField(e.target)) e.preventDefault(); });
  document.addEventListener('selectstart', function (e) { if (!isField(e.target)) e.preventDefault(); });
  document.addEventListener('keydown', function (e) {
    var k = (e.key || '').toLowerCase();
    var mod = e.ctrlKey || e.metaKey;
    if (k === 'f12') { e.preventDefault(); return; }
    if (mod && e.shiftKey && (k === 'i' || k === 'j' || k === 'c')) { e.preventDefault(); return; }
    if (mod && e.altKey && (k === 'i' || k === 'j' || k === 'c' || k === 'u')) { e.preventDefault(); return; }
    if (mod && (k === 'u' || k === 's')) { e.preventDefault(); return; }
    if (mod && (k === 'c' || k === 'a' || k === 'x') && !isField(e.target)) { e.preventDefault(); }
  });
})();
